import Logger from "js-logger";

export const InitializeLogger = () => Logger.useDefaults();
